import { render, staticRenderFns } from "./SalesChartCurve.vue?vue&type=template&id=348be269&"
import script from "./SalesChartCurve.vue?vue&type=script&lang=js&"
export * from "./SalesChartCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports